export default __webpack_public_path__ + "static/media/circles.279fac35.png";